import { useRef } from "react";
import debounce from "lodash/debounce";

const useDebounce = (fn = () => {}, time = 250) => useRef(debounce(fn, time)).current;

export default useDebounce;
